import React from "react";
import { ModelViewer } from "./model.viewer";

interface ModelViewerEmbedProps {
  modelUrl: string;
  className?: string;
  onReady?: () => void;
  onError?: (error: unknown) => void;
}

export const ModelViewerEmbed = ({ modelUrl, className, onReady, onError }: ModelViewerEmbedProps) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const onReadyRef = React.useRef(onReady);
  const onErrorRef = React.useRef(onError);

  React.useEffect(() => {
    onReadyRef.current = onReady;
  }, [onReady]);

  React.useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);

  React.useEffect(() => {
    if (!containerRef.current || !modelUrl) {
      return;
    }

    const viewer = new ModelViewer();
    let active = true;
    let reportedError = false;

    const reportError = (error: unknown) => {
      if (!active || reportedError) {
        return;
      }
      reportedError = true;
      onErrorRef.current?.(error);
    };

    viewer.init(containerRef.current, modelUrl, { onError: reportError }).then(() => {
      if (!active) {
        return;
      }
      if (reportedError) {
        return;
      }
      onReadyRef.current?.();
    }).catch((error) => {
      reportError(error);
    });

    return () => {
      active = false;
      viewer.dispose();
    };
  }, [modelUrl]);

  return <div ref={containerRef} className={className} data-testid="artwork-model-viewer" />;
};

export default ModelViewerEmbed;
